import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-ContentProfiles', [
  'addButton',
  'profilesList',
  'titleInput',
  'acsfLevelSelect',
  'descriptionInput',
  'learnerContextInput',
  'addCastMemberButton',
  'castMemberCard',
  'castMemberRoleSelect',
  'castMemberPersonaSelect',
  'castMemberDeleteButton',
  'saveButton',
  'deleteDialog',
  'loadingSpinner',
  'emptyState',
]);
